module.exports = __webpack_public_path__ + "img/like_active.5e5d3ed1.png";